import _ from 'lodash';
import React, { Component } from 'react';
import { Translation } from "react-i18next";
import { MeasurementSetting } from '../../models/settings/MeasurementSettings';
import IThresholdSettings from '../../models/settings/ThresholdSettings';
import * as CONSTANTS from "../../utilities/Constants";
import utility from '../shared/Utility';
import ValueRangeStatus from '../shared/ValueRangeStatus';
import ReportTrendGraph from './ReportTrendGraph';
import i18next from 'i18next';

interface IReportProps {
    sampleData: any;
    columns: any[];
    data: any[];
    internalColumns: any[];
    isPrintClicked: boolean;
    thresholdSettings: IThresholdSettings[];
    settings: MeasurementSetting;
}



export default class ReportTable extends Component<IReportProps> {
    private reportTypeTable = ({ rowData }: any) => {
        if (this.props.sampleData.reportType === CONSTANTS.VALUE_REPORT) {
            const maxcountsReading = _.maxBy(rowData?.readings, (a: any) => a?.positionCounts?.totalCounts);
            return <React.Fragment>
                <tr>
                    <th />
                    <th />
                    {this.props.internalColumns.map(({ path, name }: any) => (
                        <th key={path}>{i18next.t(name)}</th>
                    ))}
                    <th className="value-row" colSpan={6}>
                        {maxcountsReading?.countValues?.map((values: any, i: number) => (
                            i === 0 ? <div className="fl position-row position-row-header" key={Math.random()} >
                                {i18next.t(CONSTANTS.LABEL_COUNT)}
                            </div> : null))
                        }
                    </th>
                </tr>
                {rowData?.readings?.sort(utility.sortAlphaNum)?.map((data: any) => {
                    return <tr key={Math.random()}>
                        <td />
                        <td />
                        {this.props.internalColumns.map(({ path, type }: any) => {
                            return < td className="value-row" key={path} >
                                {type === 'number' ? data[path] != null ? data[path]?.toFixed(rowData?.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC : data[path]}
                            </td>
                        })}
                        <td className="border-left no-radius" colSpan={6} style={{ textAlign: 'center' }}>
                            {data.countValues?.map((values: any, i: number) => {
                                const low1 = this.props.thresholdSettings.find(x => x.name === "Alarm Low 1" || x.name === "Alarm Limit1");
                                const low2 = this.props.thresholdSettings.find(x => x.name === "Alarm Low 2" || x.name === "Alarm Limit2");
                                const reject = this.props.thresholdSettings.find(x => x.name === "Reject Low" || x.name === "Reject Limit");
                                if (data.countValues.length === i + 1) {
                                    return <div className="fl position-row" key={i}>
                                        <div className="position-row-header" key={Math.random()}>{values["count"]}</div>
                                        <div className="position-sub-row-border" style={{ width: "fit-content", margin: "0px auto", position: 'relative' }} >
                                            {values.valueRange?.name.includes("Alarm Limit1") ?
                                                <div style={{ background: low1?.colorCode, height: 8, width: 8, position: 'absolute', marginTop: 7, border: 'solid 2px #bababa' }} />
                                                : null}
                                            {values.valueRange?.name.includes("Alarm Limit2") ?
                                                <div style={{ background: low2?.colorCode, height: 8, width: 8, position: 'absolute', marginTop: 7, border: 'solid 2px #bababa' }} /> : null}
                                            {values.valueRange?.name.includes("Reject Limit") ?
                                                <div style={{ background: reject?.colorCode, height: 8, width: 8, position: 'absolute', marginTop: 7, border: 'solid 2px #bababa' }} /> : null}

                                            <span style={{ marginLeft: values.valueRange?.name.includes("Alarm Limit1") || values.valueRange?.name.includes("Alarm Limit2") || values.valueRange?.name.includes("Reject Limit") ? "10px" : "0px" }}>{values.value != null ? values.value?.toFixed(rowData?.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC}</span>
                                        </div></div>
                                } else {
                                    return <div className="fl position-row" key={i}>
                                        <div className="position-row-header">{values["count"]}</div>
                                        <div className="position-sub-row-border" style={{ width: "fit-content", margin: "0px auto", position: 'relative' }} >
                                            {values.valueRange?.name.includes("Alarm Limit1") ?
                                                <div style={{ background: low1?.colorCode, height: 8, width: 8, position: 'absolute', marginTop: 7, border: 'solid 2px #bababa' }} /> : null}
                                            {values.valueRange?.name.includes("Alarm Limit2") ?
                                                <div style={{ background: low2?.colorCode, height: 8, width: 8, position: 'absolute', marginTop: 7, border: 'solid 2px #bababa' }} /> : null}
                                            {values.valueRange?.name.includes("Reject Limit") ?
                                                <div style={{ background: reject?.colorCode, height: 8, width: 8, position: 'absolute', marginTop: 7, border: 'solid 2px #bababa' }} /> : null}

                                            <div><span style={{ marginLeft: values.valueRange?.name.includes("Alarm Limit1") || values.valueRange?.name.includes("Alarm Limit2") || values.valueRange?.name.includes("Reject Limit") ? "10px" : "0px" }}>{values.value != null ? values.value?.toFixed(rowData?.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC}</span></div>
                                        </div>
                                    </div>
                                }
                            })}
                        </td>
                    </tr>
                })
                }
            </React.Fragment>

        } else if (this.props.sampleData.reportType === CONSTANTS.POSITION_REPORT) {
            const limits: any = { AlarmHigh1: rowData.alarmHigh1, AlarmHigh2: rowData.alarmHigh2, AlarmLow1: rowData.alarmLow1, AlarmLow2: rowData.alarmLow2, RejectHigh: rowData.rejectHigh, RejectLow: rowData.rejectLow }
            return <React.Fragment>
                <tr key={Math.random()}>
                    <td />
                    <td />
                    <td colSpan={8}>
                        {rowData?.readings?.sort(utility.sortAlphaNum)?.map((data: any, i: number) => {
                            const low1 = this.props.thresholdSettings.find(x => x.name === "Alarm Low 1" || x.name === "Alarm Limit1");
                            const low2 = this.props.thresholdSettings.find(x => x.name === "Alarm Low 2" || x.name === "Alarm Limit2");
                            const reject = this.props.thresholdSettings.find(x => x.name === "Reject Low" || x.name === "Reject Limit");
                            const valueRange = utility.getValueRange(data.positionMean, limits);
                            let color = "";
                            if (valueRange === ValueRangeStatus.Reject) {
                                color = reject?.colorCode;
                            }
                            else if (valueRange === ValueRangeStatus.Limit1) {
                                color = low1?.colorCode;
                            }
                            else if (valueRange === ValueRangeStatus.Limit2) {
                                color = low2?.colorCode;
                            }
                            return <div className="fl position-row-value" key={i}>
                                <div className="position-row-header-value" key={Math.random()}>{data.positionName}</div>
                                <div className={`text-center position-sub-row abb-wrapper
                                    ${rowData?.readings?.length === 1 ? 'position-sub-row-all-border' : ''}
                                    ${i % 9 === 0 && i !== 0 ? 'position-sub-row-border-right' : ''}
                                    ${i % 10 === 0 && i !== 0 ? 'position-sub-row-border-left' : ''}`}
                                    key={Math.random()} >
                                    <div style={{ background: color, height: 8, width: 8, position: 'absolute', float: 'left', top: '40%', left: '8%', border: color ? 'solid 2px #bababa' : '' }}></div>
                                    <div style={{ "borderRight": "1px solid grey" }}>{data.positionMean != null ? data.positionMean?.toFixed(rowData?.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC} </div>
                                </div></div>
                        })
                        }
                    </td>
                </tr>

            </React.Fragment>
        } else if (this.props.sampleData.reportType === CONSTANTS.GRAPH_REPORT) {
            return <React.Fragment>
                <ReportTrendGraph
                    rowData={rowData}
                    settings={this.props.settings}
                    thresholdSettings={this.props.thresholdSettings}
                />
            </React.Fragment>
        }
    }

    private getAlarmValues = (rowData: any) => {
        let withinLimitCount = 0;
        let alarm1Count = 0;
        let alarm2Count = 0;
        let rejectCount = 0;

        rowData.readings.forEach((reading: any) => {
            reading.countValues.forEach((countValue: any) => {
                const valueRangeName = countValue.valueRange.name;
                if (valueRangeName === "Within Limit") {
                    withinLimitCount++;
                } else if (valueRangeName === "Alarm Limit1") {
                    alarm1Count++;
                } else if (valueRangeName === "Alarm Limit2") {
                    alarm2Count++;
                } else if (valueRangeName === "Reject Limit") {
                    rejectCount++
                }
            });
        });
        return {
            withinLimitCount,
            alarm1Count,
            alarm2Count,
            rejectCount
        };
    }


    render() {
        return (
            <Translation>
                {
                    t => <div className="abb-wrapper">
                        <div className={`abb-scroller ${!this.props.isPrintClicked ? 'height-45-vh' : ''}`}>
                            <table className="abb-value-report w-100">
                                {this.props.isPrintClicked &&
                                    <thead>
                                        <tr className="ng-gray sticky" style={{ zIndex: 9999 }}>
                                            {this.props?.columns?.map(({ path, name }: any, index: number) => (
                                                <th key={index} className="row-header">{t(name)}</th>
                                            ))}
                                        </tr></thead>}
                                <tbody>
                                    {!this.props.isPrintClicked && <tr className="ng-gray sticky" style={{ zIndex: 9999 }}>
                                        {this.props?.columns?.map(({ path, name }: any, index: number) => (
                                            <th key={index} className="row-header">{t(name)}</th>
                                        ))}
                                    </tr>}

                                    {this.props.data ? this.props?.data?.map((rowData: any, index: number) => {
                                        const limits: any = { AlarmHigh1: rowData.alarmHigh1, AlarmHigh2: rowData.alarmHigh2, AlarmLow1: rowData.alarmLow1, AlarmLow2: rowData.alarmLow2, RejectHigh: rowData.rejectHigh, RejectLow: rowData.rejectLow }
                                        const low1 = this.props.thresholdSettings.find(x => x.name === "Alarm Low 1" || x.name === "Alarm Limit1");
                                        const low2 = this.props.thresholdSettings.find(x => x.name === "Alarm Low 2" || x.name === "Alarm Limit2");
                                        const reject = this.props.thresholdSettings.find(x => x.name === "Reject Low" || x.name === "Reject Limit");
                                        const valueRange = utility.getValueRange(rowData.mean, limits);
                                        const alarmValues = this.getAlarmValues(rowData);
                                        let color = "";
                                        if (valueRange === ValueRangeStatus.Reject) {
                                            color = reject?.colorCode;
                                        }
                                        else if (valueRange === ValueRangeStatus.Limit1) {
                                            color = low1?.colorCode;
                                        }
                                        else if (valueRange === ValueRangeStatus.Limit2) {
                                            color = low2?.colorCode;
                                        }
                                        return <React.Fragment key={Math.random()}>
                                            {
                                                <tr className={this.props.sampleData.reportType !== CONSTANTS.REEL_REPORT ? "prop-bg" : ""}>
                                                    {this.props.columns.map(({ path, type, i }: any) => {
                                                        return (
                                                            <td className="row-data abb-wrapper" key={path}>
                                                                {path === 'mean' && this.props.sampleData.reportType === CONSTANTS.REEL_REPORT ? <div style={{ background: color, height: 8, width: 8, float: 'left', top: '40%', marginTop: '6%', marginRight: '4px', border: color ? 'solid 2px #bababa' : '' }}></div> : ''}
                                                                {/* <div>{type === 'number' ? (rowData[path] === "alarm1" || rowData[path] === "alarm2") ? rowData[path] : rowData[path]?.toFixed(rowData?.decimals) : rowData[path]}</div> */}
                                                                <div>
                                                                    {type === 'number' ? (
                                                                        path === "alarm1" ? alarmValues.alarm1Count :
                                                                        path === "alarm2" ? alarmValues.alarm2Count :
                                                                                rowData[path]?.toFixed(rowData?.decimals)
                                                                    ) : rowData[path]}
                                                                </div>
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            }
                                            {this.reportTypeTable({ rowData })}
                                        </React.Fragment>
                                    }) : null}
                                </tbody>
                            </table>
                        </div>
                    </div >
                }
            </Translation>
        )
    }
}